var app = angular.module("leonardo");

var OnBoardingAccountUserAdd = function($scope, AccountService, NavigationService, AuthDataService) {
  $scope.skip = function() {
    AccountService.onboardingFinished(AuthDataService.authData.account).then(function() {
      if ((AuthDataService.isAdmin() || AuthDataService.isWhiteLabelAdmin()) || AuthDataService.authData.user.is_white_label_admin) {
        NavigationService.goToStaffLoggedHome();
      }
      else {
        NavigationService.goToUserLoggedHome();
      }
    });
  };
};

app.controller('OnBoardingAccountUserAdd', ['$scope', 'AccountService', 'NavigationService', 'AuthDataService',
  OnBoardingAccountUserAdd]);
